import { render } from "./AllCategories.vue?vue&type=template&id=6fdb859d&scoped=true"
import script from "./AllCategories.vue?vue&type=script&lang=js"
export * from "./AllCategories.vue?vue&type=script&lang=js"

import "./AllCategories.vue?vue&type=style&index=0&id=6fdb859d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdb859d"]])

export default __exports__